import { makeStyles } from 'tss-react/mui';

const useStylesModalSwipeableSlider: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  modalSwipeableSliderSlide: {
    minHeight: 400,
  },
  modalSwipeableSliderImage: {
    width: 'auto',
    height: 'auto',
    maxWidth: 750,
    maxHeight: 500,
    padding: 20,
    [theme.breakpoints.down('lg')]: {
      maxWidth: 550,
      maxHeight: 400,
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: 450,
      maxHeight: 300,
    },
  },
}));

export default useStylesModalSwipeableSlider;
